<template>
    <v-card flat>
        <v-card-title>
            <v-text-field ref="search" v-model="search" append-icon="search" label="Search" clearable single-line hide-details solo class="elevation-2"></v-text-field>
            <v-spacer></v-spacer>
            <v-switch v-model="allHistory" label="Display all" color="success"></v-switch>
			<v-spacer></v-spacer>
			<v-btn @click="pdf" flat icon>
				<v-icon>picture_as_pdf</v-icon>
			</v-btn>
        </v-card-title>
        <v-data-table hide-actions must-sort :headers="headers" :items="borrowingHistory" :search="search" :pagination.sync="pagination" class="elevation-1">
            <template v-slot:items="props">
                <td>{{ props.item.collection }}</td>
                <td>{{ props.item.title }}</td>
                <td>{{ props.item.author }}</td>
                <td>{{ props.item.checkOutDate.toLocaleDateString( 'en-au' ) }}</td>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2 pb-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
        </div>
    </v-card>
</template>

<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
	name: 'HistoryListTab',
	data ( ) {
		return {
			allHistory: false,
			pagination: {
				page: 1,
				rowsPerPage: 10,
				sortBy: 'checkOutDate',
				descending: true
			},
			rowsPerPage: [
				10,
				25,
				50,
				{
					"text": "$vuetify.dataIterator.rowsPerPageAll",
					"value":-1
				}
			],
			search: '',
			headers: [
				{
					text: 'Type',
					value: 'collection',
					sortable: false,
					header: 'Type',
					dataKey: 'collection',
				},
				{
					text: 'Title',
					value: 'title',
					header: 'Title',
					dataKey: 'title'
				},
				{
					text: 'Author',
					value: 'author',
					header: 'Author',
					dataKey: 'author'
				},
				{
					text: 'Borrowed',
					value: 'checkOutDate',
					header: 'Borrowed',
					dataKey: 'checkOutDate'
				}
			]
		}
	},
	mounted( ) {
        this.$refs.search.focus( );
	},
	computed: {
		pages () {
			if ( this.pagination.rowsPerPage == null || this.pagination.rowsPerPage == -1 || this.pagination.totalItems == null ) return 0
			return Math.ceil( this.pagination.totalItems / this.pagination.rowsPerPage );
		},
		borrowingHistory( ) {
			return this.$store.getters[ 'patron/borrowingHistory' ];
		},
		borrowingHistoryCount( ) {
			return this.$store.getters[ 'patron/borrowingHistoryCount' ];
		}
	},
	watch: {
		allHistory( updated, orginial ) {
			if ( updated ) {
				this.pagination.rowsPerPage = -1;
			} else {
				this.pagination.rowsPerPage = 10;
			}
		}
	},
	methods: {
		pdf( ) {
			var title = 'Borrowing History';
			var data = this.borrowingHistory;
			var sortBy = this.pagination.sortBy;
			var sortByTitle = this.headers.filter( item => {
				return item.value == sortBy;
			} );
			// start nastyness for filtering
			var search = this.search;
			if ( search !== '' ) {
				title += ' - Search: "' + search + '"';
			}
			data = data.filter( function( item ) {
				// combine collection, title and author
				var all = item.collection.toUpperCase( ).concat( item.title.toUpperCase( ), item.author.toUpperCase( ) );
				// add checkout date
				all = all.concat( new Date( item.checkOutDate ).toLocaleDateString( 'en-au' ) );
				// return if search is in the combined data
				return all.includes( search.toUpperCase( ) );
			} );
			// end nastyness for filtering
			// start nastyness for sorting
			if ( !this.pagination.descending ) {
				title += ' - Sort: ' + sortByTitle[ 0 ].header;
				data.sort( function( a, b ) {
					var a1 = typeof( a[ sortBy ] ) == 'string' ? a[ sortBy ].toUpperCase( ) : a[ sortBy ];
					var b1 = typeof( b[ sortBy ] ) == 'string' ? b[ sortBy ].toUpperCase( ) : b[ sortBy ];
					if ( a1 < b1 ) {
						return -1;
					}
					if ( a1 > b1 ) {
						return 1;
					}
					return 0;
				} );
			}
			if ( this.pagination.descending ) {
				title += ' - Sort: ' + sortByTitle[ 0 ].header + ' DESC';
				data.sort( function( a, b ) {
					var a1 = typeof( a[ sortBy ] ) == 'string' ? a[ sortBy ].toUpperCase( ) : a[ sortBy ];
					var b1 = typeof( b[ sortBy ] ) == 'string' ? b[ sortBy ].toUpperCase( ) : b[ sortBy ];
					if ( a1 < b1 ) {
						return 1;
					}
					if ( a1 > b1 ) {
						return -1;
					}
					return 0;
				} );
			}
			// end nastyness
			const doc = new jsPDF( );
			doc.text( title, 14, 22 );
			doc.autoTable( {
				columns: this.headers,
				body: data,
				columnStyles: {
					collection: {
						cellWidth: 'wrap'
					},
					checkOutDate: {
						cellWidth: 25
					}
				},
				didParseCell: function( data ) {
					if ( data.row.section === 'body' && data.column.dataKey === 'checkOutDate' ) {
						// hack at end for IE/Edge - https://github.com/MrRio/jsPDF/issues/937
						data.cell.text = new Date( data.cell.text ).toLocaleDateString( 'en-au' ).replace( /[\u200E]/g, '' );
					}
				},

				startY: 25,
			} );
			doc.save( 'borrowing_history.pdf' );

		}
	}
}
</script>
